import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth
} from '@backstage/integration-react'
import { apiDocsConfigRef } from '@backstage/plugin-api-docs'
import { AnyApiFactory, configApiRef, createApiFactory } from '@backstage/core-plugin-api'
import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api'
import ApiDocPluginFactory from './asyncapi'
import { DataTechRadarApi } from './custom/techRadar/techRadarApi'
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar'

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi)
  }),
  ScmAuth.createDefaultApiFactory()
]

// An API may only be provided by the plugin that owns it — the owner is inferred
// from the ref id, so `plugin.api-docs.config` belongs to `api-docs` and
// `plugin.techradar.service` to `tech-radar`. Providing either from the `app`
// plugin (which is where `convertLegacyAppOptions` puts the `apis` above) fails
// startup with `API_FACTORY_CONFLICT`. Instead we override them through a module
// for the owning plugin, naming the extension after the API ref id so it matches
// — and therefore replaces — the extension the converted legacy plugin registers.
export const pluginApiOverrides = [
  // plugin-api-docs patch included in this app
  createFrontendModule({
    pluginId: 'api-docs',
    extensions: [
      ApiBlueprint.make({
        name: apiDocsConfigRef.id,
        params: defineParams =>
          defineParams({
            api: apiDocsConfigRef,
            deps: {},
            factory: ApiDocPluginFactory
          })
      })
    ]
  }),
  createFrontendModule({
    pluginId: 'tech-radar',
    extensions: [
      ApiBlueprint.make({
        name: techRadarApiRef.id,
        params: defineParams =>
          defineParams({
            api: techRadarApiRef,
            deps: {},
            factory: () => new DataTechRadarApi()
          })
      })
    ]
  })
]
